import { useState, type ReactNode } from 'react';
import { VisitorContext } from './VisitorContext';

type Props = {
  children: ReactNode;
};

export const VisitorContextProvider = ({ children }: Props) => {
  const [isCollaboratorView, setIsCollaboratorView] = useState(true);

  return (
    <VisitorContext.Provider
      value={{ isCollaboratorView, setIsCollaboratorView }}
    >
      {children}
    </VisitorContext.Provider>
  );
};
